module.exports = __webpack_public_path__ + "img/Lövet.0da00ec6.jpg";